import axios from 'src/utils/axios';

export const sendSubscriptionToPushServer = userSubscription => {
    try {
        if (!userSubscription || Object.keys(userSubscription).length === 0) {
            return Promise.resolve({ data: { success: false, message: 'Empty subscription' } });
        }

        // 2. İSTEK: Mevcut axios çağrınız
        const response = axios.post('/PushNotification/Subscribe', userSubscription, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        return Promise.resolve({ data: { success: false, message: 'Empty subscription' } });
    }
};
export const getNotifications = () => {
    return axios.get('/PushNotification');
};
export const notifyNotificationViewed = id => {
    return axios.delete(`/PushNotification/${id}`);
};
